import { render } from "./NavSidebarLayout.vue?vue&type=template&id=aa29c8de"
import script from "./NavSidebarLayout.vue?vue&type=script&lang=js"
export * from "./NavSidebarLayout.vue?vue&type=script&lang=js"

import "./NavSidebarLayout.vue?vue&type=style&index=0&id=aa29c8de&lang=scss"
script.render = render

export default script